import React, { useEffect, useRef, useState } from "react";
import { number, object, string } from "prop-types";

import FilterDateRangePicker from "../../atoms/FilterDateRangePicker";
import AuthorsSearchInput from "../AuthorsSearchInput";
import SectionSearchInput from "../SectionSearchInput";
import StoryTypeSearchInput from "../StoryTypeSearchInput";
import SortingSearch from "../SortingSearch";
import Icons from "../../icons";

import { staticTexts } from "../../utils/Translate";
import { openCheck, toBanglaNum } from "../../utils/utils";
import { useDevice } from "../../utils/react-utils";

import "./search-filter.m.css";

const SearchFilter = ({ className, query = {}, lang = "bn", total = 0 }) => {
  const [handlerOpen, setHandlerOpen] = useState(openCheck(query));
  const openRef = useRef();
  const { mobile, tab } = useDevice();

  useEffect(() => {
    if (openRef && (mobile || tab)) {
      if (handlerOpen) {
        openRef.current.style.overflow = "hidden";
        setTimeout(() => {
          openRef.current.style.overflow = "unset";
        }, 300);
      } else {
        openRef.current.style.overflow = "hidden";
      }
    }
  }, [handlerOpen, mobile, tab]);

  return (
    <div className={className} styleName="base">
      <div styleName={`filter-top ${handlerOpen ? "open" : "close"}`}>
        <div styleName="open-close-handler" onClick={() => setHandlerOpen((prev) => !prev)}>
          <label styleName="handler-text">{staticTexts(lang).specificSearch}</label>
          <Icons type={handlerOpen ? "list-close" : "list-open"} styleName="handler-button" />
        </div>
        <div styleName="filter-inputs" ref={openRef}>
          <FilterDateRangePicker query={query} styleName="date-picker-filter" lang={lang} />
          <AuthorsSearchInput query={query} lang={lang} />
          <SectionSearchInput query={query} lang={lang} />
          <StoryTypeSearchInput query={query} lang={lang} />
        </div>
      </div>
      <div styleName="filter-bottom">
        <div styleName="total-result">
          <span styleName="total-title">{staticTexts(lang).resultsObtained}</span>
          <div styleName="total-colon">:</div>
          <span styleName="total-number">{lang === "bn" ? toBanglaNum(total) : total}</span>
        </div>
        <SortingSearch query={query} lang={lang} />
      </div>
    </div>
  );
};

SearchFilter.propTypes = {
  query: object,
  className: string,
  lang: string,
  total: number,
};

export default SearchFilter;
